import index from "../index/en.js"
import login from "../login/fr.js"
import projectList from "../projectList/fr.js"
import post from "../post/fr.js"
import admin from "../admin/fr.js"

export default {
  index,
  login,
  projectList,
  post,
  admin
}



// WEBPACK FOOTER //
// ./src/locale/lang/fr.js